export default "__VITE_ASSET__BF72bweU__"